import { EventType } from './event-type.interface';

export const CONTACT_SENSOR: EventType = {
  name: 'Contact Switch',
  description: 'When a Contact Switch is triggered',
  route: 'contact-sensor',
  category: 'Security & Access',
  icon: 'relay',
  whitelist: [
    {
      proxy: 'control4_contactsingle',
      events: [1, 2]
    },
    {
      proxy: 'contactsingle_contactswitch_c4',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/contact-sensor.type.ts